import { Box, Button, Typography } from "@mui/material";
import { t } from "i18next";
import type { ReactNode } from "react";
import { Flex } from "@/components/layout/flex/flex";
import error500Svg from "@/assets/error-500.svg";
import { isErrorResponseData } from "@/types/error.types";
import { DebugInformationAlert } from "@/components/alerts/debug-information-alert/debug-information-alert";

function DefaultActions() {
	return (
		<Flex mt={2} gap={2} justifyContent="center">
			<Button>{t("Visit our help center")}</Button>
			<Button
				onClick={() => window.location.reload()}
				variant="contained"
				color="primary"
			>
				{t("Back to application")}
			</Button>
		</Flex>
	);
}

export function UnknownErrorPage({
	actions = <DefaultActions />,
	title = "That's on us",
	description = "Something went wrong on our side while processing your request",
	cause,
}: {
	title?: string;
	actions?: ReactNode;
	description?: string;
	cause?: unknown;
}) {
	return (
		<Flex
			height="100%"
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
		>
			<Box p={2} display="flex" flexDirection="column" alignItems="center">
				<img
					src={error500Svg}
					alt="500 Error"
					style={{ maxWidth: "400px", width: "100%" }}
				/>
				<Typography mt={4} variant="h6">
					{t(title)}
				</Typography>
				<Typography mt={1} variant="body2" color="text.secondary">
					{t(description)}
				</Typography>
				<Typography variant="body2" color="text.secondary">
					{t("If the problem continues, contact ")}
					<a href="mailto:support@battmobility.be">support@battmobility.be</a>
					{"."}
				</Typography>
				<Flex mt={4} width="min(90vw, 700px)" flexDirection="column" gap={2}>
					{import.meta.env.DEV && isErrorResponseData(cause) && (
						<DebugInformationAlert cause={cause} />
					)}
					{actions}
				</Flex>
			</Box>
		</Flex>
	);
}
